import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { ref, watchEffect } from '../../adapter-vue';
import { isPC, isUniFrameWork } from '../../utils/env';
import SelectFriend from './select-friend/index.vue';
import ContactList from './contact-list/index.vue';
import ContactInfo from './contact-info/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // web/h5 单页面应用展示形式，uniapp 请忽略
    displayType: {
      type: String,
      default: 'contactList',
      require: false
    }
  },
  emits: ['switchConversation'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var displayTypeRef = ref(props.displayType || 'contactList');
    var isShowSelectFriend = ref(false);
    var isShowContactList = ref(true);
    var isShowContactInfo = ref(true);
    watchEffect(() => {
      isShowContactList.value = (props === null || props === void 0 ? void 0 : props.displayType) !== 'selectFriend';
    });
    TUIStore.watch(StoreName.CUSTOM, {
      isShowSelectFriendComponent: data => {
        if (!isUniFrameWork && (props === null || props === void 0 ? void 0 : props.displayType) === 'selectFriend') {
          isShowSelectFriend.value = data;
          isShowContactList.value = false;
          return;
        }
        if (data) {
          isShowSelectFriend.value = true;
          if (isUniFrameWork) {
            displayTypeRef.value = 'selectFriend';
            TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.hideTabBar();
          }
        } else {
          isShowSelectFriend.value = false;
          if (isUniFrameWork) {
            displayTypeRef.value = props.displayType;
            TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.showTabBar();
          }
        }
      },
      currentContactInfo: contactInfo => {
        var _Object$keys;
        isShowContactInfo.value = isPC || contactInfo && typeof contactInfo === 'object' && ((_Object$keys = Object.keys(contactInfo)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
      }
    });
    var switchConversation = data => {
      isUniFrameWork && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.navigateTo({
        url: '/TUIKit/components/TUIChat/index'
      }));
      emits('switchConversation', data);
    };
    return (_ctx, _cache) => {
      return _unref(isShowSelectFriend) ? (_openBlock(), _createBlock(SelectFriend, {
        key: 0
      })) : _unref(isShowContactList) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tui-contact', !_unref(isPC) && 'tui-contact-h5'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['tui-contact-left', !_unref(isPC) && 'tui-contact-h5-left'])
      }, [_createVNode(ContactList, {
        class: _normalizeClass(['tui-contact-left-list', !_unref(isPC) && 'tui-contact-h5-left-list'])
      }, null, 8, ["class"])], 2), _unref(isShowContactInfo) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['tui-contact-right', !_unref(isPC) && 'tui-contact-h5-right'])
      }, [_createVNode(ContactInfo, {
        onSwitchConversation: switchConversation
      })], 2)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }
});